interface SiniestroConLugarOcurrencia {
    lugarOcurrenciaCompleto?: boolean;
    lugarOcurrencia?: {
        calle?: string | null;
        altura?: string | null;
        idLocalidad?: number | null;
        localidad?: { id?: number | null } | null;
    } | null;
}

// Sin calle, altura y localidad no se puede cargar una visita al siniestro. La regla la
// calcula el back (SMP-585); el cálculo local cubre las respuestas que no traen el flag.
// Piso, depto y CP no cuentan
export const tieneLugarOcurrenciaCompleto = (siniestro?: SiniestroConLugarOcurrencia | null) => {
    if (typeof siniestro?.lugarOcurrenciaCompleto === 'boolean') {
        return siniestro.lugarOcurrenciaCompleto;
    }

    const lugarOcurrencia = siniestro?.lugarOcurrencia;

    return Boolean(
        String(lugarOcurrencia?.calle || '').trim() &&
        String(lugarOcurrencia?.altura || '').trim() &&
        Number(lugarOcurrencia?.localidad?.id || lugarOcurrencia?.idLocalidad)
    );
};
